import Vue from 'vue'
import App from './App'
import axios from 'axios'

import vuetify from './plugins/vuetify'
import store from "./store/index"
import i18n from "./plugins/vue-i18n"
import router from './plugins/router'

import './utils/polyfill'
import './components/sly'
import './plugins/vuetifyDialog'
// import './plugins/analytics'
import VueGtag from 'vue-gtag'

// css
import './assets/common/css/default.css'
import './assets/common/css/survey.css'

export const bus = new Vue()

Vue.prototype.$http = axios
Vue.config.productionTip = false


//cookie
Vue.prototype.$getCookie = function (cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};

Vue.prototype.$setCookie = function (cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

/* eslint-disable no-new */
new Vue({
    el: '#app',
    components: { App },
    template: '<App/>',
    store,
    vuetify,
    router,
    i18n
})

if (process.env.VUE_APP_GOOGLE_ANALYTICS_BASIC) {
    Vue.use(VueGtag, {
        config: {
            id: `${process.env.VUE_APP_GOOGLE_ANALYTICS_BASIC}`,
            params: {
                send_page_view: false,
            },
            pageTrackerScreenviewEnabled: true,
        },
    }, router)
}